import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
  TableHead,
  Table,
  Button,
  TextField,
  IconButton,
  Select,
  MenuItem,
  Checkbox,
  Modal,
  Skeleton,
  InputAdornment,
  Autocomplete,
  CircularProgress,
  AccordionSummary,
  Accordion,
  AccordionDetails,
  Paper,
  FormControl,
  InputLabel,
} from "@mui/material";
import { headingStyle, tableRowLab } from "../../style/LapPageStyle";
import CloseIcon from "@mui/icons-material/Close";
import {
  menuItemStyle,
  primaryBtn,
  textfieldText,
} from "../../style/AppointmentStyle";
import {
  autoFocusOffWithOutBorder,
  drTableRowBlueBg,
} from "../../style/PatinetFormStyle";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import updownar from "../../assets/updownar.svg";
import RemoveRedEyeRoundedIcon from "@mui/icons-material/RemoveRedEyeRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";
import TuneRoundedIcon from "@mui/icons-material/TuneRounded";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { DeleteForeverRounded } from "@mui/icons-material";
import json_icon from "../../assets/json_icon.svg";
import csv_icon from "../../assets/csv_icon.svg";
import CustomModal from "../CustomModal/CustomModal";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import EditMedicines from "./EditMedicines";
import NewMedicines from "./NewMedicines";
import medicines_icon from "../../assets/medicine.svg";
import MedicinesDetails from "./MedicinesDetails";
import UseFetchMedicineAdmin from "../../helper/UseFetchMedicineAdmin";
import { primaryBtnTeal } from "../../style/PatientDetailsStyle";
import { Link, useNavigate } from "react-router-dom";
import {
  generateCSV,
  handleDownloadCsvMedicine,
  handleShowJson,
  formattedDate,
} from "../../utils/constantFunctions";
import { showToast } from "../../utils/toastUtil";
import { deleteMedicine } from "../../connections/deleteApi";
import SearchIcon from "@mui/icons-material/Search";
import useDebounce from "../../hooks/UseDebounce";
import useFetchMedicineEnquiry from "../../helper/useFetchMedicineEnquiry";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import dayjs from "dayjs";
import { handleExportMedicineEnquiry } from "../../connections/getApi";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";

const MedicinesEnquiry = ({ onClose }) => {
  // console.log(medicines);
  const navigate = useNavigate();

  const [filterModal, setFilterModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [detailsModal, setDetailsModal] = useState(false);
  const [editPurchaseOrderModal, setEditPurchaseOrderModal] = useState(false);
  const [newPurchaseOrderModal, setNewPurchaseOrderModal] = useState(false);
  const [page, setPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(10);
  const [id, setId] = useState(null);
  const [goToPage, setGoToPage] = useState("");
  const [medicineSelected, setMedicineSelected] = useState("");
  const [searchText, setSearchText] = useState("");
  const [openSearchDropDown, setOpenSearchDropDown] = useState("");
  const [exportLoading, setExportLoading] = useState(false);

  const [startDate, setStartDate] = useState(
    dayjs().tz("Asia/Kolkata").format("YYYY-MM-DD"),
  );
  const [endDate, setEndDate] = useState(
    dayjs().tz("Asia/Kolkata").format("YYYY-MM-DD"),
  );

  const today = dayjs();
  const ninetyDaysAgo = today.subtract(1, "year");

  // ====== handler to attach to TextField if you still want it ======
  const handleFormChange = (e) => {
    const val = e?.target?.value ?? "";
    setSearchText(val);
    // if (medicineSelected) setMedicineSelected(val);
  };

  const handleStartDateChange = (e) => {
    const value = e.target.value;
    const selectedDate = dayjs(value);

    // Clamp start date: min 90 days ago, max today
    if (selectedDate.isBefore(ninetyDaysAgo)) {
      setStartDate(ninetyDaysAgo.format("YYYY-MM-DD"));
    } else if (selectedDate.isAfter(today)) {
      setStartDate(today.format("YYYY-MM-DD"));
    } else {
      setStartDate(value);
    }

    // Adjust end date if it's before start + 1
    if (endDate) {
      const minEnd = selectedDate.add(1, "day");
      if (dayjs(endDate).isBefore(minEnd)) {
        setEndDate(minEnd.format("YYYY-MM-DD"));
      }
    }
  };

  const handleEndDateChange = (e) => {
    const value = e.target.value;
    const selectedDate = dayjs(value);
    const minEnd = dayjs(startDate).add(1, "day");

    if (selectedDate.isBefore(minEnd)) {
      setEndDate(minEnd.format("YYYY-MM-DD"));
    } else if (selectedDate.isAfter(today)) {
      setEndDate(today.format("YYYY-MM-DD"));
    } else {
      setEndDate(value);
    }
  };

  const debouncedSearch = useDebounce(searchText, 500);
  const { data: medicineList, isLoading: loadingMedicine } =
    UseFetchMedicineAdmin(1, 10, debouncedSearch);

  const {
    data: medicineEnquiryList,
    refetch,
    isLoading,
  } = useFetchMedicineEnquiry(
    medicineSelected?.id,
    page,
    itemPerPage,
    startDate,
    endDate,
  );
  // console.log(medicineEnquiryList, ' medicineEnquiryList')

  const totalRecords = medicineEnquiryList?.meta?.total_count || 0;
  const totalPage = Math.ceil(totalRecords / itemPerPage) || 0;

  const handlePrevious = () => {
    if (page > 1) setPage((prev) => prev - 1);
  };

  const handleNext = () => {
    console.log(page, totalPage, "(page , totalPage");
    if (page < totalPage) setPage((prev) => prev + 1);
  };

  const handleDelete = async (id) => {
    setDeleteModal(false);
    const res = await deleteMedicine(id);
    //  console.log(res);

    showToast(res?.status?.message || res?.status?.status, res?.status?.status);
    if (res?.status?.status) {
      refetch(page, itemPerPage);
    }
  };

  const dedupeItems = (items = []) => {
    return items.reduce(
      (acc, item) => {
        const key = `${item?.invoice_uid}-${item?.name}-${item?.date}`;

        if (!acc?.map[key]) {
          acc.map[key] = true;
          acc.list.push(item);
        }

        return acc;
      },
      { map: {}, list: [] },
    ).list;
  };

  // const handleExport = async () => {
  //     handleExportMedicineEnquiry
  // };

  return (
    <>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          height: "90vh",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        {/* //modals for delete and filter */}
        <Modal
          open={deleteModal}
          onClose={() => setDeleteModal(false)}
          sx={{
            position: "absolute",
            top: "25%",
            // left:'50%',
            width: "450px",
            // height:"400px",
            margin: "auto",
            //  display: "flex",
            //  alignItems: "flex-start",
            //  justifyContent: "center",
            //  overflow: "auto",
            borderRadius: "20px",
          }}
        >
          <Box
            sx={{
              mt: 2,
              bgcolor: "background.paper",
              borderRadius: 3.6,
              boxShadow: 24,
              p: 4.5,
              "&:focus": {
                outline: "none",
              },
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography textAlign={"center"}>Are you sure?</Typography>
              <Typography textAlign={"center"}>
                You want to delete these selected purchase orders?
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "flex",
                gap: "25px",
                width: "max-content",
                margin: "auto",
                marginTop: "40px",
              }}
            >
              <Button
                onClick={() => handleDelete(id)}
                sx={{
                  backgroundColor: "#FF392B",
                  color: "white",
                  border: "",
                  width: "150px",
                  borderRadius: "5px",
                  fontSize: "12px",
                  textTransform: "capitalize",
                  "&:hover": {
                    backgroundColor: "red",
                  },
                }}
              >
                Delete
              </Button>
              <Button
                onClick={() => setDeleteModal(false)}
                sx={{
                  backgroundColor: "white",
                  color: "black",
                  border: "2px solid #FF392B",
                  width: "150px",
                  borderRadius: "5px",
                  fontSize: "12px",
                  textTransform: "capitalize",
                }}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </Modal>

        <Modal
          open={filterModal}
          onClose={() => setFilterModal(false)}
          sx={{
            position: "absolute",
            top: "14%",
            // left:'50%',
            width: "340px",
            // height:"400px",
            margin: "auto",
            //  display: "flex",
            //  alignItems: "flex-start",
            //  justifyContent: "center",
            //  overflow: "auto",
            borderRadius: "20px",
          }}
        >
          <Box
            sx={{
              mt: 2,
              bgcolor: "background.paper",
              borderRadius: "20px",
              boxShadow: 24,
              p: 1,
              "&:focus": {
                outline: "none",
              },
            }}
          >
            <Grid container spacing={2} sx={{ padding: "9px" }}>
              <Grid item xs={12}>
                <Typography
                  variant="subTitle116px"
                  fontWeight={"600"}
                  textAlign={"center"}
                  margin={"auto"}
                >
                  Filters
                </Typography>
              </Grid>

              {/* <Grid item xs={12}>
        <Typography  variant="subTitle116px" >Suppliers</Typography>
      </Grid> */}

              {/* Filter Selection */}
              <Grid item xs={12}>
                <Select
                  fullWidth
                  defaultValue=""
                  placeholder="Select Filter"
                  sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Remove border
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Remove border on hover
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Ensure border remains none on focus
                    },
                    "& .MuiSelect-select": {
                      padding: "9px",
                      borderRadius: "15px",
                      backgroundColor: "#F7F7FF",
                    },
                    "&:hover": {
                      boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                    },
                  }}
                  renderValue={(selected) => {
                    if (!selected) {
                      return (
                        <span style={{ color: "text.default_grey" }}>
                          Select filter
                        </span>
                      );
                    }
                    return selected === "filter1"
                      ? "filter2"
                      : selected === "filter3"
                        ? "filter3"
                        : "select filter";
                  }}
                >
                  <MenuItem value="filter1">Filter 1</MenuItem>
                  <MenuItem value="filter2">Filter 2</MenuItem>
                  <MenuItem value="filter3">Filter 3</MenuItem>
                </Select>
              </Grid>

              {/* Purchase Date */}
              <Grid item xs={12}>
                <Typography variant="subTitle116px">Purchase Date</Typography>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  sx={autoFocusOffWithOutBorder}
                  label="From"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  sx={autoFocusOffWithOutBorder}
                  label="To"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              {/* Department Selection */}
              <Grid item xs={12}>
                <Typography variant="subTitle116px">Department</Typography>
                <Select
                  fullWidth
                  defaultValue=""
                  sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Remove border
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Remove border on hover
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Ensure border remains none on focus
                    },
                    "& .MuiSelect-select": {
                      padding: "9px",
                      borderRadius: "15px",
                      backgroundColor: "#F7F7FF",
                    },
                    "&:hover": {
                      boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                    },
                  }}
                >
                  <MenuItem value="dept1">Department 1</MenuItem>
                  <MenuItem value="dept2">Department 2</MenuItem>
                  <MenuItem value="dept3">Department 3</MenuItem>
                </Select>
              </Grid>

              {/* Created At */}
              <Grid item xs={12}>
                <Typography variant="subTitle116px">Created At</Typography>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  sx={autoFocusOffWithOutBorder}
                  label="From"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  sx={autoFocusOffWithOutBorder}
                  label="To"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              {/* Buttons */}
              <Grid item xs={6}>
                <Button
                  fullWidth
                  variant="subTitle116px16px"
                  sx={{ ...primaryBtnTeal, color: "white" }}
                >
                  Apply
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  onClick={() => setFilterModal(false)}
                  fullWidth
                  variant="subTitle116px16px"
                  sx={{ ...primaryBtn, color: "white", border: "none" }}
                >
                  Clear Filters
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        <Box
          sx={{
            overflowY: "auto",
            maxHeight: "80vh",
            "&::-webkit-scrollbar": {
              display: "none",
            },
            "-ms-overflow-style": "none",
            "scrollbar-width": "none",
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            position="sticky"
          >
            <Box></Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <img
                src={medicines_icon}
                alt=""
                sx={{
                  color: "neutral.navyBlue",
                  marginBottom: "4px",
                  marginRight: "8px",
                }}
              />
              <Typography
                variant="heading_Large"
                fontWeight={700}
                gutterBottom
                sx={headingStyle}
              >
                Medicine Spend Details
              </Typography>
            </Box>
            <IconButton sx={{ marginBottom: "r0em" }} onClick={onClose}>
              <CloseIcon size="small" sx={{ color: "red" }} />
            </IconButton>
          </Box>

          <Box
            mt={2}
            mb={-1}
            marginLeft={-1}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            position="sticky"
            paddingX="25px"
          >
            <Box>
              <Autocomplete
                freeSolo
                popupIcon={false}
                open={openSearchDropDown}
                // inputValue={inputValue}
                sx={{
                  ...autoFocusOffWithOutBorder,
                  "& .MuiOutlinedInput-root": {
                    paddingX: "8px", // No padding inside the input field
                    paddingY: "1.5px",
                    borderRadius: "15px",
                    backgroundColor: "white",
                    minWidth: 310,
                    borderRadius: "8px",
                  },
                }}
                onOpen={() => setOpenSearchDropDown(true)}
                onClose={() => {
                  setOpenSearchDropDown(false);
                }}
                onChange={(event, newValue) => {
                  if (newValue) {
                    setSearchText("");
                  }
                  setMedicineSelected(newValue);
                }}
                onInputChange={(event, newInputValue) => {
                  setSearchText(newInputValue);
                  // handleInputChange(event, newInputValue);
                }}
                options={medicineList?.payload?.medicines || []}
                filterOptions={(options) => options}
                getOptionLabel={(option) => option?.name || ""}
                renderOption={(props, option) => (
                  <MenuItem
                    key={option.id + Math.random()}
                    // onClick={() => selectedPatient(option)}
                    {...props}
                    sx={{
                      ...menuItemStyle,
                      width: "100%",
                      //   "&:hover, &.Mui-focused": {
                      //     backgroundColor: "#0067FF40 !important",
                      //     color: "black !important",
                      //   },
                    }}
                  >
                    {option?.name}
                  </MenuItem>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    name="Search Medicine"
                    onChange={handleFormChange}
                    required
                    id="search"
                    placeholder="Search Medicine"
                    variant="outlined"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {loadingMedicine ? (
                            <CircularProgress color="inherit" size={18} />
                          ) : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            </Box>

            <Box sx={{ gap: 5, display: "flex" }}>
              {/* Start Date */}
              <FormControl variant="outlined" sx={{ width: "160px" }}>
                {/* Start Date */}
                <TextField
                  type="date"
                  label="Start Date"
                  value={startDate}
                  onChange={handleStartDateChange}
                  sx={textfieldText}
                  inputProps={{
                    min: ninetyDaysAgo.format("YYYY-MM-DD"),
                    max: today.format("YYYY-MM-DD"),
                  }}
                />
              </FormControl>

              {/* End Date */}
              <FormControl variant="outlined" sx={{ width: "160px" }}>
                {/* End Date */}
                <TextField
                  type="date"
                  label="End Date"
                  value={endDate}
                  sx={textfieldText}
                  onChange={handleEndDateChange}
                  inputProps={{
                    min: startDate
                      ? dayjs(startDate).add(1, "day").format("YYYY-MM-DD")
                      : ninetyDaysAgo.format("YYYY-MM-DD"),
                    max: today.format("YYYY-MM-DD"),
                  }}
                />
              </FormControl>

              {medicineSelected?.id && (
                <Button
                  onClick={() => {
                    handleExportMedicineEnquiry(
                      medicineSelected?.id,
                      "exports",
                      startDate,
                      endDate,
                    );
                  }}
                  sx={{ ...primaryBtnTeal, color: "white" }}
                  disabled={exportLoading}
                >
                  <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                    <CloudDownloadOutlinedIcon size={20} />
                    Export
                  </Box>
                </Button>
              )}
            </Box>
          </Box>

          <Grid item xs={12} mt={4}>
            <TableContainer>
              {isLoading && (
                <Table>
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={12} sx={{ p: 0 }}>
                        <Box
                          sx={{
                            rowGap: 1.2,
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <Skeleton
                            variant="rectangular"
                            sx={{
                              width: "100%",
                              height: "50px", // Adjust to match your table row height
                              backgroundColor: "#f0f0f0", // Light grey color
                            }}
                          />

                          <Skeleton
                            variant="rectangular"
                            sx={{
                              width: "100%",
                              height: "50px", // Adjust to match your table row height
                              backgroundColor: "#f0f0f0", // Light grey color
                            }}
                          />
                          <Skeleton
                            variant="rectangular"
                            sx={{
                              width: "100%",
                              height: "50px", // Adjust to match your table row height
                              backgroundColor: "#f0f0f0", // Light grey color
                            }}
                          />

                          <Skeleton
                            variant="rectangular"
                            sx={{
                              width: "100%",
                              height: "50px", // Adjust to match your table row height
                              backgroundColor: "#f0f0f0", // Light grey color
                            }}
                          />
                          <Skeleton
                            variant="rectangular"
                            sx={{
                              width: "100%",
                              height: "50px", // Adjust to match your table row height
                              backgroundColor: "#f0f0f0", // Light grey color
                            }}
                          />
                        </Box>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              )}

              {medicineEnquiryList?.payload?.medicine_enquiries?.map(
                (medicine, i) => (
                  <Accordion
                    key={i}
                    disableGutters
                    defaultExpanded
                    sx={{
                      // marginY: 2,
                      boxShadow: "none",
                      // borderRadius: 10,
                      borderBottom: "1px solid #ccc",
                      // boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;'
                      // borderTop: '0px',
                    }}
                  >
                    {/* Date Header */}
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography variant="subtitle1" fontWeight={600}>
                        {medicine?.date}
                      </Typography>
                    </AccordionSummary>

                    {/* Table inside accordion */}
                    <AccordionDetails>
                      <Table sx={{ width: "100%", marginTop: -3 }}>
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">Patient ID</TableCell>
                            <TableCell align="center">Bill No</TableCell>
                            <TableCell align="center">Date</TableCell>
                            <TableCell align="center">Name</TableCell>
                            <TableCell align="center">Batch</TableCell>
                            <TableCell align="center">Receive</TableCell>
                            <TableCell align="center">Issue</TableCell>
                            <TableCell align="center">Stock Left</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {dedupeItems(medicine?.invoices?.invoice_items).map(
                            (item, idx) => (
                              <TableRow
                                key={idx}
                                sx={{
                                  ...tableRowLab,
                                  textAlign: "center",
                                  backgroundColor: "#F7F7FF",
                                  borderBottom: "8px solid white",
                                  borderTop: "2px solid white",
                                }}
                              >
                                <TableCell
                                  sx={{
                                    borderTopLeftRadius: "20px",
                                    borderBottomLeftRadius: "20px",
                                    color: "neutral.black",
                                    p: "6px",
                                    textAlign: "center",
                                  }}
                                >
                                  {" "}
                                  <Typography variant="subTitle116px">
                                    {" "}
                                    {item?.patient_uid || "-"}{" "}
                                  </Typography>
                                </TableCell>
                                <TableCell
                                  sx={{
                                    color: "neutral.black",
                                    p: "6px",
                                    textAlign: "center",
                                  }}
                                >
                                  {" "}
                                  <Typography variant="subTitle116px">
                                    {" "}
                                    {item?.invoice_uid || "-"}{" "}
                                  </Typography>{" "}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    color: "neutral.black",
                                    p: "6px",
                                    textAlign: "center",
                                  }}
                                >
                                  {" "}
                                  <Typography variant="subTitle116px">
                                    {" "}
                                    {item?.date || "-"}{" "}
                                  </Typography>{" "}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    color: "neutral.black",
                                    p: "6px",
                                    textAlign: "center",
                                  }}
                                >
                                  {" "}
                                  <Typography variant="subTitle116px">
                                    {" "}
                                    {item?.name || "-"}{" "}
                                  </Typography>
                                </TableCell>
                                <TableCell
                                  sx={{
                                    color: "neutral.black",
                                    p: "6px",
                                    textAlign: "center",
                                  }}
                                >
                                  {" "}
                                  <Typography variant="subTitle116px">
                                    {" "}
                                    {item?.batch || "-"}{" "}
                                  </Typography>
                                </TableCell>
                                <TableCell
                                  sx={{
                                    color: "neutral.black",
                                    p: "6px",
                                    textAlign: "center",
                                  }}
                                >
                                  {" "}
                                  <Typography variant="subTitle116px">
                                    {" "}
                                    {item?.received_quantity || "-"}{" "}
                                  </Typography>{" "}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    color: "neutral.black",
                                    p: "6px",
                                    textAlign: "center",
                                  }}
                                >
                                  {" "}
                                  <Typography variant="subTitle116px">
                                    {" "}
                                    {item?.quantity || "-"}{" "}
                                  </Typography>{" "}
                                </TableCell>

                                <TableCell
                                  sx={{
                                    borderTopRightRadius: "20px",
                                    borderBottomRightRadius: "20px",
                                    color: "neutral.black",
                                    p: "6px",
                                    textAlign: "center",
                                  }}
                                >
                                  {" "}
                                  <Typography variant="subTitle116px">
                                    {" "}
                                    {item?.stock_left || "-"}{" "}
                                  </Typography>{" "}
                                </TableCell>
                              </TableRow>
                            ),
                          )}
                        </TableBody>
                      </Table>
                    </AccordionDetails>
                  </Accordion>
                ),
              )}

              {!medicineEnquiryList?.payload?.medicine_enquiries?.length > 0 &&
                !isLoading && (
                  <Table>
                    <TableRow>
                      {" "}
                      <TableCell colSpan={6} sx={{ textAlign: "center" }}>
                        {" "}
                        {medicineSelected ? (
                          <Typography variant="h6" sx={{ fontSize: "18px" }}>
                            🔍 No invoices found for the selected medicine
                          </Typography>
                        ) : (
                          <Typography variant="h6" sx={{ fontSize: "18px" }}>
                            ! Please select a medicine to view spend details
                          </Typography>
                        )}{" "}
                      </TableCell>{" "}
                    </TableRow>
                  </Table>
                )}
            </TableContainer>
          </Grid>
        </Box>

        <Box
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          flexWrap="wrap"
          gap={1}
          sx={{ zIndex: 10, px: "20px", mb: "5px" }}
        >
          {/* Previous */}
          <Button
            onClick={handlePrevious}
            disabled={page === 1}
            startIcon={<ArrowBackIcon sx={{ fontSize: "14px" }} />}
            sx={{ fontSize: "12px", textTransform: "none", color: page === 1 ? "#9e9e9e" : "#007A99", "&:disabled": { color: "#9e9e9e" } }}
          >
            Prev
          </Button>

          {/* Windowed page numbers */}
          {(() => {
            if (totalPage <= 7) return [...Array(totalPage)].map((_, i) => i + 1);
            const pages = [];
            pages.push(1);
            if (page > 3) pages.push("...");
            for (let p = Math.max(2, page - 1); p <= Math.min(totalPage - 1, page + 1); p++) pages.push(p);
            if (page < totalPage - 2) pages.push("...");
            pages.push(totalPage);
            return pages;
          })().map((p, i) =>
            p === "..." ? (
              <Typography key={`ellipsis-${i}`} sx={{ fontSize: "12px", px: "4px", color: "#999" }}>…</Typography>
            ) : (
              <Button
                key={p}
                onClick={() => setPage(p)}
                sx={{
                  minWidth: "30px", height: "30px", fontSize: "12px", borderRadius: "6px", p: "2px",
                  color: page === p ? "#fff" : "#333",
                  backgroundColor: page === p ? "#007A99" : "#fff",
                  border: "1px solid #d0d0d0",
                  "&:hover": { backgroundColor: page === p ? "#007A99" : "#f2f2f2" },
                }}
              >
                {p}
              </Button>
            )
          )}

          {/* Next */}
          <Button
            onClick={handleNext}
            disabled={page === totalPage || totalPage === 0}
            endIcon={<ArrowForwardIcon sx={{ fontSize: "14px" }} />}
            sx={{ fontSize: "12px", textTransform: "none", color: (page === totalPage || totalPage === 0) ? "#9e9e9e" : "#007A99", "&:disabled": { color: "#9e9e9e" } }}
          >
            Next
          </Button>

          {/* Go to page */}
          <Box display="flex" alignItems="center" gap="4px">
            <Typography sx={{ fontSize: "12px", color: "#555" }}>Go to</Typography>
            <TextField
              size="small"
              value={goToPage}
              onChange={(e) => setGoToPage(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  const n = parseInt(goToPage, 10);
                  if (n >= 1 && n <= totalPage) { setPage(n); setGoToPage(""); }
                }
              }}
              sx={{ width: "60px", "& input": { fontSize: "12px", padding: "6px 8px" }, "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
            />
          </Box>

          {/* Rows per page */}
          <FormControl size="small" sx={{ minWidth: 80 }}>
            <InputLabel sx={{ fontSize: "12px" }}>Rows</InputLabel>
            <Select
              value={itemPerPage}
              label="Rows"
              onChange={(e) => { setItemPerPage(e.target.value); setPage(1); }}
              sx={{ fontSize: "12px", borderRadius: "8px" }}
            >
              {[10, 20, 50, 100].map((n) => (
                <MenuItem key={n} value={n} sx={{ fontSize: "12px" }}>{n}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Box>

      <CustomModal
        customStyles={{ border: "none", minWidth: "85%" }}
        open={detailsModal}
        setDetailsModal
        onClose={() => setDetailsModal(false)}
      >
        <MedicinesDetails
          onClose={() => setDetailsModal(false)}
          id={id}
          refetch={refetch}
          page={page}
          itemPerPage={itemPerPage}
        />
      </CustomModal>

      <CustomModal
        customStyles={{ border: "none", minWidth: "85%", maxWidth: "90%" }}
        open={editPurchaseOrderModal}
        onClose={() => setEditPurchaseOrderModal(false)}
      >
        <EditMedicines
          onClose={() => setEditPurchaseOrderModal(false)}
          refetch={refetch}
          page={page}
          itemPerPage={itemPerPage}
        />
      </CustomModal>

      <CustomModal
        customStyles={{ border: "none", minWidth: "85%", maxWidth: "90%" }}
        open={newPurchaseOrderModal}
        onClose={() => setNewPurchaseOrderModal(false)}
      >
        <NewMedicines
          onClose={() => setNewPurchaseOrderModal(false)}
          refetch={refetch}
        />
      </CustomModal>
    </>
  );
};

export default MedicinesEnquiry;
